import React, { useRef } from "react";
import { Card, CardHeader, CardBody, CardFooter } from "../card/card.jsx";
import { getAuthHeaders } from "../../misc.js";

const ReelDetailsPreview = ({
  songReelId,
  username,
  fullname,
  like_count,
  comment_count,
  caption,
  postedAt,
  profile_pic,
  video_filename,
  thumbnailImage,
  setThumbnailImage,
}) => {
  const videoRef = useRef(null);

  // Send the video filename and the current playback time to the backend.
  const handleCaptureFrame = async () => {
    if (videoRef.current) {
      const video = videoRef.current;
      const currentTime = video.currentTime;
  
      try {
        const response = await fetch("https://api.moatoverflow.com/v1/song_reel/get_still_image", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ video_filename, currentTime }),
        });
        const data = await response.json();
  
        if (data.success && data.filename) {
          const newThumbnail = data.filename;
          setThumbnailImage(newThumbnail);
  
          // Immediately update the backend with this thumbnail
          await fetch(`https://api.moatoverflow.com/v1/song_reel/${video_filename.replace(".mp4", "")}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              ...getAuthHeaders()
            },
            body: JSON.stringify({ thumbnail_frame_still: newThumbnail }),
          });
        } else {
          console.error("Error capturing image:", data.message);
        }
      } catch (error) {
        console.error("Error sending data to get_still_image:", error);
      }
    }
  };

  const handleThumbnailUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    const formData = new FormData();
    formData.append("thumbnail", file);
    
    try {
      const response = await fetch("https://api.moatoverflow.com/v1/song_reel/upload/thumbnail", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.success && data.filename) {
        // Update the thumbnail preview with the new image.
        setThumbnailImage(data.filename);
        
        // Update the backend reel document using the _id
        await fetch(`https://api.moatoverflow.com/v1/song_reel/${songReelId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...getAuthHeaders()
          },
          body: JSON.stringify({ still_frame: data.filename }),
        });
      } else {
        console.error("Error processing thumbnail:", data.message);
      }
    } catch (error) {
      console.error("Error uploading thumbnail:", error);
    }
  };
  
  return (
    <>
      <Card>
        <CardHeader>
          <h4>Reel Details</h4>
        </CardHeader>
        <CardBody>
          <div className="row mb-3">
            <div className="col">
              <label className="form-label">Username:</label>
              <input type="text" readOnly className="form-control" value={username} />
            </div>
            <div className="col">
              <label className="form-label">Fullname:</label>
              <input type="text" readOnly className="form-control" value={fullname} />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col">
              <label className="form-label">Like Count:</label>
              <input type="text" readOnly className="form-control" value={like_count} />
            </div>
            <div className="col">
              <label className="form-label">Comment Count:</label>
              <input type="text" readOnly className="form-control" value={comment_count} />
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Caption:</label>
            <input type="text" readOnly className="form-control" value={caption} />
          </div>
          <div className="mb-3">
            <label className="form-label">Posted At:</label>
            <input type="text" readOnly className="form-control" value={postedAt} />
          </div>
          <div className="mb-3">
            <label className="form-label">Profile Pic:</label>
            <img src={"https://api.moatoverflow.com/images/" + profile_pic} alt="Profile" className="img-fluid" width={96} height={96} />
          </div>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>
          <h4>Reel & Thumbnail Preview</h4>
        </CardHeader>
        <CardBody>
          <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
            <div style={{ flex: "1" }}>
              <video
                ref={videoRef}
                controls
                width="100%"
                crossOrigin="anonymous"
                src={`https://api.moatoverflow.com/videos/${video_filename}`}
              >
                Your browser does not support the video tag.
              </video>
            </div>
            <div
              style={{
                flex: "1",
                position: "relative",
                paddingTop: "56.25%",
              }}
            >
              {thumbnailImage && (
                <div>
                  <img
                    src={`https://api.moatoverflow.com/images/${thumbnailImage}`}
                    alt="Still frame"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </CardBody>
        <CardFooter>
          <button onClick={handleCaptureFrame} className="btn btn-success mt-2">
            Capture Frame & Remove BG
          </button>
          <input 
            type="file" 
            accept="image/*" 
            onChange={handleThumbnailUpload} 
            className="form-control mt-2"
          />
        </CardFooter>
      </Card>
    </>
  );
};

export default ReelDetailsPreview;
